import { useRef } from 'react';
import { ReactComponent as CrownSvg } from '../../assets/svg/crown.svg';
import PayDialog from './payDialog';

const Premium = ({ refreshUser }) => {
  const dialogRef = useRef(null);

  const openDialog = () => {
    if (dialogRef.current) {
      dialogRef.current.showModal();
    }
  };

  const closeDialog = () => {
    if (dialogRef.current) {
      dialogRef.current.close();
    }
  };

  return (
    <div className='flex justify-center'>
      <button
        className='flex gap-2 items-center justify-center text-sm font-bold rounded-full py-3 w-11/12 bg-yellow-500 text-black'
        onClick={openDialog}
      >
        <CrownSvg className='size-4' /> Go Premium
      </button>
      <PayDialog
        dialogRef={dialogRef}
        closeDialog={closeDialog}
        title='Go Premium'
        refreshUser={refreshUser}
      />
    </div>
  );
};

export default Premium;
